























import { EventBus } from "../event-bus.js";

export default {
  props: {
    contentEnabled: Boolean,
    isCompatible: Boolean,
    pois: Object,
    currentPoi: Object,
  },
  data() {
    return {
      iframeUrl:
        "https://app.plattar.com/webgleditor/preview/index.html?debug=false&helpslides=false&sceneId=",
      sceneId: "8a013450-2160-11eb-af05-2dcf8eda028a",
    };
  },
  mounted: function () {
    if (document.getElementById("plattar-frame").contentDocument) {
      //we are doing Hot Module Reload
      this.initPlattar();
    }
  },
  methods: {
    onLoad: function (e) {
      console.log("IFRAME ONLOAD");
      this.initPlattar(e);
    },
    emitNavigate(loc) {
      this.$emit("navigate", loc);
    },
    initPlattar: function (e) {
      var origin =
        location.protocol +
        "//" +
        location.hostname +
        (location.port ? ":" + location.port : "");
      this.$root.comms = new PlattarViewerCommunicator();
      this.$root.comms.init("plattar-frame");

      this.$root.comms.send("initpreview", {
        origin: origin,
      });

      this.$root.comms.on("setLoading", function (data) {
        console.log("SETLOADIONG");
        console.log(data);
      });

      EventBus.$emit("plattar-init");
    },
  },
};
